import dynamic from 'next/dynamic';
import { useState } from 'react';

import useThreadsDownloaderStaticContentData from './data';
import ThreadsDownloaderSearch from './ThreadsSearch';
import { ThreadsDownloaderContentData } from './types';

const StepContent = dynamic(() => import('../LandingPage/StepContent'), { ssr: true });
const DownloadInstagramContent = dynamic(() => import('../LandingPage/DownloadInstagramContent'), { ssr: true });
const ChooseContent = dynamic(() => import('../LandingPage/ChooseContent'), { ssr: true });
const GeneralExampDownloadContent = dynamic(() => import('../LandingPage/GeneralExampDownloadContent'), {
  ssr: true,
});
const WhyDownloadStoriesContent = dynamic(() => import('../LandingPage/WhyDownloadStoriesContent'), {
  ssr: true,
});
const FAQContent = dynamic(() => import('../LandingPage/FAQContent'), { ssr: true });
const BestTipsContent = dynamic(() => import('../LandingPage/BestTipsContent'), { ssr: true });

const mergeContentData = (data: ThreadsDownloaderContentData, staticData: ThreadsDownloaderContentData) => {
  return Object.assign({}, data, { contentInfo: { ...data?.contentInfo, ...staticData.contentInfo } });
};

interface ThreadsDownloaderProps {
  data: any;
}

const ThreadsDownloader: React.FC<ThreadsDownloaderProps> = (props) => {
  const { staticContentData } = useThreadsDownloaderStaticContentData();

  const [contentData, setContentData] = useState<ThreadsDownloaderContentData>(
    mergeContentData(props.data.contentData, staticContentData)
  );

  return (
    <>
      <ThreadsDownloaderSearch>
        <StepContent data={contentData.contentInfo['section-0']} />
        <DownloadInstagramContent data={contentData?.contentInfo['section-1']} />
        <ChooseContent data={contentData?.contentInfo['section-2']} />
        <GeneralExampDownloadContent data={contentData?.contentInfo['section-3']} />
        <WhyDownloadStoriesContent data={contentData?.contentInfo['section-4']} />

        {contentData?.faqList && (
          <FAQContent faqInfo={contentData?.contentInfo?.['section-faq']} faqList={contentData?.faqList} />
        )}
        <BestTipsContent
          title={contentData?.contentInfo?.['section-top-blog']?.title}
          blogList={contentData?.topBlogList}
        />
        <BestTipsContent title={contentData?.contentInfo?.['section-blog']?.title} blogList={contentData?.blogList} />
      </ThreadsDownloaderSearch>
    </>
  );
};

export default ThreadsDownloader;
